/*=============================
=      Blog Filter by Tag     =
=============================*/

var tag = getParameter(window.location, 'tag'),
	author = getParameter(window.location, 'author'),
	search = getParameter(window.location, 'search'),
	currentPage = 1,
	sidebar = document.querySelector('#sidebar .tags'),
	postsContainer = document.getElementById('posts-list'),
	pagination = document.getElementById('pagination');

[].slice.call(document.querySelectorAll('body#blog #hero a[href*="?tag="], #sidebar .tags a')).forEach(function(link) {
	link.addEventListener('click', function(e) {
		if(window.location.href.indexOf('?author=') < 0 && window.location.href.indexOf('?search=') < 0) {
			e.preventDefault();

			if(!this.classList.contains('current')) {
				currentPage = 1;
				tag = getParameter(this, 'tag');

				var currentTag = sidebar.querySelector('a.current'),
					selectedTag = hero.contains(this) ? sidebar.querySelector('a[href*="?tag='+tag+'"]') : this;

				if(currentTag)
					currentTag.classList.remove('current');

				if(selectedTag)
					selectedTag.classList.add('current');

				axios.post('/blog-load', {page: currentPage, tag: tag, author: author, search: search})
				.then(function(r) {
					if(r.data.blogs) {
						postsContainer.style.minHeight = '0px';
						postsContainer.innerHTML = r.data.blogs;

						setTimeout(function() {
							scrollToElement(document.getElementById('blog-sidebar'));
						}, 500);

						if(r.data.last)
							pagination.classList.add('hidden');
						else
							pagination.classList.remove('hidden');
					}
				})
				.catch(function (e) {
					console.log(e);
				});
			}
		}
	});
});

if(window.location.href.indexOf('?tag=') > -1)
	scrollToElement(document.getElementById('blog-sidebar'));

/*=============================
=        Blog Load More       =
=============================*/

var loadMore = pagination.querySelector('button');

loadMore.addEventListener('click', function() {
	this.setAttribute('disabled', true);

	postsContainer.style.minHeight = postsContainer.offsetHeight+'px';

	axios.post('/blog-load', {page: ++currentPage, tag: tag, author: author, search: search})
	.then(function(r) {
		if(r.data.blogs) {
			postsContainer.innerHTML+= r.data.blogs;
			Velocity(postsContainer, 'slideDown', {duration: 500, display: checkWidth(768) ? 'block' : 'flex'});
			loadMore.removeAttribute('disabled');

			if(r.data.last)
				pagination.classList.add('hidden');
			else
				pagination.classList.remove('hidden');
		}
	})
	.catch(function (e) {
		console.log(e);
	});
});

/*=============================
=      Pinned Blog Mobile     =
=============================*/

var pinnedBlog = document.querySelector('body.blog #hero-content');

if(pinnedBlog) {
	pinnedBlog.addEventListener('click', function() {
		if(checkWidth(768))
			window.location.href = this.querySelector('.bg-wrapper').href;
	});
}